import "./inputfield.css";
import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../button/MasterButton";
import { useState } from "react";

export enum InputfieldType {
  Normal,
  Error,
  Success,
}

export type InputfieldProps = {
  value: string;
  leftIcon?: JSX.Element;
  rightActionIcon?: JSX.Element;
  onRightActionClicked?: () => void;
  onValueChanged: (value: string) => void;
  type: InputfieldType;
  collapsable: boolean;
  placeholderValue: string;
};

const InputfieldWithPlaceholder: React.FC<InputfieldProps> = ({ value, onValueChanged, leftIcon, rightActionIcon, onRightActionClicked, type, collapsable, placeholderValue }) => {
  const [isCollapsed, setCollapsed] = useState(collapsable);

  const [dynamicPlaceholderValue, setdynamicPlaceholderValue] = useState("");

  function getMainClassName(type: InputfieldType) {
    const collapsed = isCollapsed ? " collapsed" : "";

    if (type === InputfieldType.Success) {
      return "inputfield success" + collapsed;
    } else if (type === InputfieldType.Error) {
      return "inputfield error" + collapsed;
    } else {
      return "inputfield" + collapsed;
    }
  }

  return (
    <div className={getMainClassName(type)}>
      {leftIcon && <div className="left-icon">{leftIcon}</div>}
      <input
        className={leftIcon ? "input-area title-small" : "input-area left-aligned title-small"}
        value={value}
        placeholder={dynamicPlaceholderValue}
        onFocus={() => {
          setCollapsed(false);
          setdynamicPlaceholderValue(placeholderValue);
        }}
        onChange={(event) => {
          onValueChanged(event.target.value);
          setdynamicPlaceholderValue(placeholderValue);
        }}
        onBlur={() => {
          if (collapsable && value === "") {
            setCollapsed(true);
          }
          setdynamicPlaceholderValue("");
        }}
      ></input>
      <div className="overlay"></div>

      {rightActionIcon && !isCollapsed && (
        <MasterButton
          options={{
            layoutType: ButtonLayoutType.Icon,
            size: ButtonSize.XS,
            variation: ButtonVariation.Clean,
            label: "",
            icon: rightActionIcon,
            className: "right-action-icon",
          }}
          onClick={() => {
            console.log("Right Action Clicked");

            if (onRightActionClicked) {
              if (collapsable) setCollapsed(true);

              onRightActionClicked();
              setdynamicPlaceholderValue("");
            }
          }}
        ></MasterButton>
      )}
    </div>
  );
};

export default InputfieldWithPlaceholder;
